import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { StihlVideoDTO } from '../models/stihl-video-dto';
import { ChangeOrderDTO } from '../models/change-order-dto';

@Injectable({
  providedIn: 'root'
})

export class VideoService {

  private pathAPI = environment.urlAPI;
  private controller = "StihlVideo/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<StihlVideoDTO> {
    return this.http.get<StihlVideoDTO>(this.pathAPI + this.controller + id);
  }

 

  public post(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: FormData): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public getDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/', data);
  }

  


}
